const types = {
  SET_ERROR: 'SET_ERROR',
  SET_AUTH_ERROR: 'SET_AUTH_ERROR',
  SET_LOADING: 'SET_LOADING',
  SET_INIT_LOADING: 'SET_INIT_LOADING',
  SET_GLOBAL_ERROR: 'SET_GLOBAL_ERROR',
  SET_DONE: 'SET_DONE',
  SET_ADMIN: 'SET_ADMIN',
  SET_FEEDBACK_SUCCESS: 'SET_FEEDBACK_SUCCESS',
  SET_FEEDBACKS: 'SET_FEEDBACKS',
  SET_SUCCESS: 'SET_SUCCESS',
  SET_DELETE_SUCCESS: 'SET_DELETE_SUCCESS',
  SET_DRIVERS: 'SET_DRIVERS',
  SET_USERS: 'SET_USERS',
  SET_RIDES: 'SET_RIDES',
  SET_RIDES_REALTIME_STAT: 'SET_RIDES_REALTIME_STAT',
  SET_CURRENT_CAR_PRICES: 'SET_CURRENT_CAR_PRICES',
};

export default types;
